module.exports = __webpack_public_path__ + "img/fig01.158e1659.jpg";